<template>

  <t-dialog-form :generalErrors="generalErrors" :title="title" :ok-text="okText" @show="showModal" @hidden="resetModal"
                 :id="id" :command="command" :status="status" :variant="variant"
                 ref="dialog_form" @onSubmit="onSubmit">


    <table class="mb-2 table-bordered table">
      <thead>
      <tr>
        <td>Ordem de Fabricação</td>
        <td>Etapa atual</td>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td><b>{{ step.productionOrderCodeLabel }}</b></td>
        <td><b>{{ step.name }}</b></td>
      </tr>
      </tbody>
    </table>


    <div v-if="type === 'return'">

      <t-input v-model="form.goProductionOrderBatchStepId" required select :options="stepOptions"
               label="Etapa desejada"/>

      <t-input v-model="form.typeStopId" required select :options="typeProductionReturnOptions" label="Motivo"/>

      <t-input v-model="form.stopNote" textarea label="Descrição adicional"/>

    </div>




    <div v-else-if="type === 'stop'">

      <t-input v-model="stopType" stacked :options="stopTypeOption" radio required/>

      <t-input v-if="stopType === 1" v-model="form.typeStopId" required select :options="typeProductionStopOptions"
               label="Motivo"/>

      <t-input v-else-if="stopType === 2" v-model="form.operationStatusId" required select
               :options="typeStatusProductionOptions" label="Status do Erro"/>


      <t-input v-model="form.stopNote" textarea label="Descrição adicional"/>


    </div>

    <div v-else-if="type === 'cancel_stop'" class="p-3">

      <h5>Deseja continuar com a produção?</h5>

    </div>

    <div v-else-if="type === 'set_responsible'">

      <t-input v-model="form.operatorId" required select
               :options="operatorOptions" label="Operador responsável"/>

    </div>

    <div v-else-if="type === 'set_operationStatus'">


      <t-input  v-model="form.operationStatusId" required select
               :options="typeStatusProductionCommonOptions" label="Status Operacional novo"/>


    </div>

    <div v-else-if="type === 'set_groupUser'">


      <b-row>

        <t-input cols="8" v-model="groupUserId" select :options="groupUserOptions"
                 label="Grupo de Usuários"/>

        <b-col cols="4">
          <t-button outline-primary form-inline @click="addGroupUser">Adicionar</t-button>

        </b-col>

      </b-row>

      <b-list-group>

        <b-list-group-item class="m-0 p-0" v-for="item in form.groupUsers" :key="item.groupUserId">

          <b-row class="d-flex align-items-center">


            <div class="col-10 d-flex align-items-center">

              <b-row>

                <div class="col-12 pt-1">

                  <b class="pl-2">{{ item.name }}</b>
                </div>
                <div class="col-12">
                  <t-input radio v-model="item.stepTypeAccess" :options="FlowStepGroupUserAccessType.list"/>

                </div>

              </b-row>


            </div>


            <div class="col-2">

              <b-icon-trash @click="addGroupSelected(false, item.groupUserId)"
                            class="text-danger opacity-6 opacity-10-hover link"/>

            </div>

          </b-row>


        </b-list-group-item>

      </b-list-group>


    </div>


  </t-dialog-form>

</template>
<script>
import tDialogForm from "@/components/template/dialog/t-dialog-form";
import pageDialogFormMixin from "@/mixins/page/pageDialogFormMixin";
import ProductionOrderStepService from "@/services/modules/production/ProductionOrderStep.service";
import StepActionType from "@/model/types/modules/production/StepActionType";
import FlowStepGroupUserAccessType from "@/model/types/modules/production/FlowStepGroupUserAccessType";
import ui from "@/assets/scripts/ui";

export default {
  name: "StepActionDialog",
  components: {tDialogForm},
  mixins: [pageDialogFormMixin],
  data() {
    return {
      id: "modal-action-step",
      title: "",
      okText: "",
      FlowStepGroupUserAccessType,
      form: {
        action: 0,
        productionOrderBatchStepId: 0,
        goProductionOrderBatchStepId: 0,
        typeStopId: 0,
        operationStatusId: 0,
        operatorId: 0,
        stopNote: "",
        groupUsers: [],
      },
      step: {},
      error: {//Campos que podem receber retorno de erro do backend
        name: "",
      },
      stopType: 1, //1 = Parada temporária 2= Definitiva
      variant: "primary",
      stopTypeOption: [{value: 1, text: 'Parada temporaria'}, {value: 2, text: 'Finalização com erro (reprovado)'}, {
        value: 3,
        text: 'Finalização com sucesso'
      }], /*Valido somente para o tipo 'stop'*/
      groupUserId: 0,
      operatorOptions: [],
      stepOptions: [],
      typeStatusProductionOptions: [],
      typeStatusProductionCommonOptions: [],
      typeProductionReturnOptions: [],
      typeProductionStopOptions: [],
      groupUserOptions: [],
      originalGroupUserOptions: []
    }
  },
  props: {
    productionOrderBatchStepId: {
      type: Number,
      required: true,
    },
    dialogId:{
      type:String,
      default:""
    },
    type: {
      type: String,
      default: "return", //return, stop, set_responsible
    },
  },
  mounted() {

    if (this.dialogId !== '') {
      this.id = this.dialogId
    }

  },
  methods: {

    /*--------------------------------------------------------------------------*/
    /*METODOS PARA DIALOGO DE GRUPO DE USUÁRIOS*/
    setGroupUserAvailable() {

      //Seta a informação inicial
      if (this.form.groupUsers.length > 0) {

        for (let item of this.form.groupUsers) {

          //Tenta encontra item na listagem de grupos ativos
          const group = this.groupUserOptions.find(a => a.value === item.groupUserId)

          if (group) {

            //Encontrado então seta o texto somente
            item.name = group.text

            //Remove da listagem
            const indexRemove = this.groupUserOptions.findIndex(a => a.value === item.groupUserId)

            if (indexRemove >= 0)
              this.groupUserOptions.splice(indexRemove, 1)

          } else {
            //Remove, pois provavelmente não é mais válido o grupo que havia sido selecionado
            this.addGroupSelected(false, item.groupUserId)
          }

        }

      }

    },

    addGroupUser() {

      if (this.groupUserId === 0) {
        ui.msgError(this, 'Selecione o grupo que deseja selecionar')
      } else {

        this.addGroupSelected(true, this.groupUserId)
        this.groupUserId = 0

      }

    },


    addGroupSelected(checked, id) {

      if (checked) {

        const el = this.form.groupUsers.find(a => a.groupUserId === id)

        //Não inserido anteriormente
        if (el == null) {

          //Encontra item na listagem
          const item = this.groupUserOptions.find(a => a.value === id)

          //Adiciona
          this.form.groupUsers.push(
              {
                groupUserId: id,
                name: item.text,
                stepTypeAccess: FlowStepGroupUserAccessType.type.FULL
              }
          )

          //Remove da listagem, pois já foi utilizado
          const indexRemove = this.groupUserOptions.findIndex(a => a.value === id)

          if (indexRemove >= 0)
            this.groupUserOptions.splice(indexRemove, 1)

        }

      } else {
        //Remover
        const indexRemove = this.form.groupUsers.findIndex(a => a.groupUserId === id)

        if (indexRemove >= 0) {

          //Remove da listagem
          this.form.groupUsers.splice(indexRemove, 1)

          //Tenta encontrar para disponibilizar novamente para seleção
          const original = this.originalGroupUserOptions.find(a => a.value === id)

          //Encontrado na lista original, por tanto retorna para listagem disponivel
          if (original) {
            this.groupUserOptions.push(original)
          }

        }


      }

    },
    /*--------------------------------------------------------------------------*/

    //Declaro sempre localmente, pois poderá realizar operações diferentes do padrão como setar algum valor padrão vindo de fora e que seria limpo pelo resetModal de forma dinamica
    async showModal() {

      //Limpa os campos
      this.resetModal()

      this.form.productionOrderBatchStepId = this.productionOrderBatchStepId

      if (this.type === 'return') {

        this.title = "Ação de Alteração de Etapa"
        this.okText = "Alterar Etapa"
        this.form.action = StepActionType.type.RETURN
        this.variant = "warning"

      } else if (this.type === 'stop') {

        this.title = "Ação de Paralização de Produção"
        this.okText = "Parar Produção"
        this.form.action = StepActionType.type.STOP
        this.variant = "danger"

      } else if (this.type === 'cancel_stop') {

        this.title = "Retorno de Produção"
        this.okText = "Sim"
        this.form.action = StepActionType.type.CANCEL_STOP

      } else if (this.type === 'set_responsible') {

        this.title = "Ação de Alterar Responsável"
        this.okText = "Alterar Responsável"
        this.form.action = StepActionType.type.SET_RESPONSIBLE

      } else if (this.type === 'set_groupUser') {

        this.title = "Ação de Alterar Grupo de Usuários"
        this.okText = "Alterar Grupos de Responsáveis"
        this.form.action = StepActionType.type.SET_GROUP_USER

      } else if (this.type === 'set_operationStatus') {

        this.title = "Ação de Alterar Status Operacional"
        this.okText = "Alterar Status Operacional"
        this.form.action = StepActionType.type.SET_OPERATION_STATUS

      } else {
        alert('Tipo não especificado de ação')
      }


      //Setar alguma informações padrão por exemplo vindo de fora
      await ProductionOrderStepService.selectStopProductionRelationList(this.form.productionOrderBatchStepId).then((list) => {

        this.step = list.step //ctepCurrent
        this.form.operatorId = this.step.operatorId
        this.operatorOptions = list.operatorOptions
        this.stepOptions = list.stepOptions
        this.typeStatusProductionOptions = list.typeStatusProductionOptions /*Somente com finalização de erro*/
        this.typeStatusProductionCommonOptions = list.typeStatusProductionCommonOptions /*Somente tipo comum*/
        this.typeProductionReturnOptions = list.typeProductionReturnOptions
        this.typeProductionStopOptions = list.typeProductionStopOptions
        this.groupUserOptions = list.groupUserOptions
        this.originalGroupUserOptions = this.groupUserOptions.slice()

        this.form.groupUsers = this.step.groupUsers

        this.setGroupUserAvailable()

      })


    },

    async onSubmit() {

      if (this.type === 'stop' && this.stopType === 2) {
        //Neste caso troca a ação de Parada de Produção por finalização com erro
        this.form.action = StepActionType.type.FINISH_WITH_ERROR
      } else if (this.type === 'stop' && this.stopType === 3) {
        this.form.action = StepActionType.type.FINISH_WITH_SUCCESS
      }

      if (this.form.action === StepActionType.type.SET_GROUP_USER && this.form.groupUsers.length === 0) {
        ui.msgError(this, "Selecione pelo menos 1(um) grupo de usuários para continuar.")
      } else {

        //Retirna o nome, pois estava apresentando erro
        for (let item of this.form.groupUsers) {
          delete item.name
        }

        //Validações específicas da tela
        await this.setInsertDialog("production/order-step/action", () => {

          //Marca para indicar qual ação foi realizada e em qual etapa
          this.itemInserted.value = this.form.action
          this.itemInserted.text = this.step.name

          this.successInsert()

        })


      }


    }
  }
}
</script>
